var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEducationWizardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 15,
    viewBox: "0 0 19 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50033 0.375L0.791992 5.125L3.95866 6.85083V11.6008L9.50033 14.625L15.042 11.6008V6.85083L16.6253 5.98792V11.4583H18.2087V5.125L9.50033 0.375ZM14.8995 5.125L9.50033 8.07L4.10116 5.125L9.50033 2.18L14.8995 5.125ZM13.4587 10.6667L9.50033 12.82L5.54199 10.6667V7.71375L9.50033 9.875L13.4587 7.71375V10.6667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationWizardIcon);
export default __webpack_public_path__ + "static/media/education-wizard-icon.e358aaf0.svg";
export { ForwardRef as ReactComponent };